<template>
    <div class="cart-action clear-float" :style="isMobile?cartActionStyle:{}">
        <div class="cart-action-left">
            <a-checkbox :indeterminate="indeterminate" @change="onCheckAllChange" :checked="checkAll">全选
            </a-checkbox>
        </div>
        <div class="cart-action-right">
            <div class="cart-total">
                合计：<span>￥{{totalPrice}}</span>
            </div>
            <div :class="{'cart-submit':true,'cart-submit-disable':selectList.length===0}" @click="submit">提交</div>
        </div>
        <PageLoading text="订单创建中..." v-if="isCreateOrder" />

    </div>

</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import PageLoading from "@components/loading/PageLoading";
    import {createOrder} from "@api/shopping-api";
    import {COURSE_ALREADY_PAID, SUCCESS} from "@constants/code";
    import {showError, showSuccessMsg} from "@utils/msg";
    import {DISPATCH_INIT_CART_LIST} from "@constants/action-type/cart-action-type";
    import {COMMIT_CHANGE_CART_SELECTED} from "@constants/mutation-type/cart-mutation-type";
    import common from "../../../mixin/common";
    const {mapState, mapGetters} = createNamespacedHelpers('cart');

    export default {
        name: "CartBottomAction",
        mixins: [common],
        components: {
            PageLoading
        },
        data() {
            return {
                isCreateOrder: false,
                cartActionStyle: {
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    margin: 0
                }
            }
        },
        methods: {
            onCheckAllChange() {
                this.$emit('check-all-change')
            },
            submit() {
                if (this.selectList.length > 0) {
                    const courseTitleList = this.selectList.map(item => {
                        return `《${item.course.courseTitle}》`;
                    });

                    this.$modal.confirm({
                        title: '结算',
                        content: `您选择了：${courseTitleList.join('，')}，合计${this.totalPrice}元。`,
                        okText: '确认购买',
                        cancelText: '我再想想',
                        onOk: () => {
                            // 创建订单成功后...
                            const courseIds = this.selectList.map(item => {
                                return item.courseId;
                            });
                            this.isCreateOrder = true;
                            createOrder(courseIds).then(res => {
                                if (res.code === SUCCESS) {
                                    // todo 跳转到详情界面
                                    showSuccessMsg("创建成功，即将跳转到支付界面...");
                                    setTimeout(() => {
                                        this.$router.push({
                                            name: 'payDetail',
                                            params: {
                                                orderId: res.order.orderId
                                            }
                                        })
                                    }, 300)
                                } else if (res.code === COURSE_ALREADY_PAID) {
                                    showSuccessMsg("已自动帮您忽略了您已拥有的课程");
                                } else {
                                    showError('创建订单失败', res.msg);
                                }
                                this.isCreateOrder = false;
                                // 重新加载一下购物车
                                this.$store.dispatch(DISPATCH_INIT_CART_LIST);
                                this.$store.commit(COMMIT_CHANGE_CART_SELECTED, {selectList: []})
                            })
                        }
                    })
                }
            }
        },
        computed: {
            ...mapState([
                "selectList",
            ]),
            ...mapGetters([
                "checkAll",
                "indeterminate",
                "totalPrice"
            ])
        }
    }
</script>

<style scoped lang="less">
    @import "../../../styles/variable";

    .cart-action {
        background-color: #eee;
        border: 1px solid #E4E4E4;
        border-right: 0;
        height: 60px;
        margin: 20px 0;

        &-left {
            float: left;
            padding: 20px 10px;

        }

        &-right {
            float: right;

            .cart-total {
                float: left;
                padding: 0 10px;
                line-height: 60px;

                span {
                    font-size: 20px;
                    color: #FF3900;
                }
            }

            .cart-submit {
                float: right;
                background-color: #FF8000;
                font-size: 20px;
                text-align: center;
                line-height: 60px;
                width: 120px;
                color: #fff;
                margin-top: -1px;
                cursor: pointer;
            }

            .cart-submit-disable {
                cursor: default;
                background: #999;
            }
        }
    }
</style>
